import tool from './util.tool.v1'; // 直接用数字调用方法需要两个点，变量则不需要  1..add(2)  var a = 1; a.add(2)
// 加法
// eslint-disable-next-line no-extend-native

Number.prototype.add = function (n) {
  var o = tool.floatCalc(this, n);
  return (o.a + o.b) / Math.pow(10, o.num);
}; // 减法
// eslint-disable-next-line no-extend-native


Number.prototype.minus = function (n) {
  var o = tool.floatCalc(this, n);
  return (o.a - o.b) / Math.pow(10, o.num);
}; // 乘法
// eslint-disable-next-line no-extend-native


Number.prototype.subtract = function (n) {
  var o = tool.floatCalc(this, n);
  return o.a * o.b / Math.pow(10, o.num * 2);
}; // 除法
// eslint-disable-next-line no-extend-native


Number.prototype.divide = function (n) {
  var o = tool.floatCalc(this, n);
  return o.a / o.b;
}; // 判断是否是数字


Number.prototype.isNumeric = function (val) {
  return !isNaN(parseFloat(val)) && isFinite(val);
};